module.exports = __webpack_public_path__ + "static/media/12.063a949b.svg";